import { Header } from '../util/headers';
export class AxiosStorage {
    constructor() {
        this.get = async (key) => {
            const value = await this.find(key);
            if (value.state !== 'cached' ||
                // Cached and fresh value
                value.createdAt + value.ttl > Date.now()) {
                return value;
            }
            // Check if his can stale value.
            if (AxiosStorage.keepIfStale(value)) {
                const stale = {
                    data: value.data,
                    state: 'stale',
                    createdAt: value.createdAt
                };
                await this.set(key, stale);
                return stale;
            }
            await this.remove(key);
            return { state: 'empty' };
        };
    }
}
/** Returns true if a invalid cache should still be kept */
AxiosStorage.keepIfStale = ({ data }) => {
    if (data?.headers) {
        return (Header.ETag in data.headers ||
            Header.LastModified in data.headers ||
            Header.XAxiosCacheEtag in data.headers ||
            Header.XAxiosCacheLastModified in data.headers);
    }
    return false;
};
